<template>
  <div class="container">
    <div class="flex">
      <div class="w-1/3">
        <h4 class="text-gray-900">Add Tasks</h4>
      </div>
      <div class="w-2/3">
        <vs-card class="p-5">
          <div class="flex flex-row space-x-4">
            <div class="w-3/5 flex-grow">
              <a-form-item label="Task Name">
                <a-input
                  v-decorator="['task',{ rules: [{ required: true, message: 'This field is required.' }] }]"
                  placeholder="Task Name"
                />
              </a-form-item>
            </div>
            <div class="flex flex-col mt-5 w-2/5">
              <div>
                <a-radio-group v-model="value">
                  <a-radio :value="1">
                    Due at
                  </a-radio>
                  <a-radio :value="2">
                    Due in
                  </a-radio>
                  </a-radio-group>
              </div>
              <a-form-item>
                <a-input
                  v-decorator="['lName',{ rules: [{ required: true, message: 'Please input your username!' }] }]"
                  placeholder="date"
                  disabled
                />
              </a-form-item>
            </div>
          </div>
          <a-form-item label="Description">
            <a-textarea
              v-decorator="['description',{ rules: [{ required: true, message: 'Please input your username!' }] }]"
              :rows="10"
              disabled
            />
          </a-form-item>
          <div class="flex flex-row">
            <div class="w-4/5">
              <a-form-item label="Assignee">
                <a-input-group compact>
                  <a-select style="width: 20%;border-top-right-radius: 0;border-bottom-right-radius: 0" default-value="Home">
                    <a-select-option value="Home">
                      Home
                    </a-select-option>
                    <a-select-option value="Company">
                      Company
                    </a-select-option>
                  </a-select>
                  <a-select style="width: 60%" default-value="Home" allowClear>
                    <a-select-option value="Home">
                      Erfan abedi
                    </a-select-option>
                    <a-select-option value="Company">
                      Ali
                    </a-select-option>
                  </a-select>
                  <a-icon type="unlock" style="border: 1px solid #ccc;padding:8px;width:10%" />
                </a-input-group>
              </a-form-item>
            </div>
            <div class="w-1/5">
              <a-form-item label="Priority">
                <a-select style="width: 100%;border-radius: 3px !important;" default-value="Normal">
                  <a-select-option value="Normal">
                    Normal
                  </a-select-option>
                  <a-select-option value="Easy">
                    Easy
                  </a-select-option>
                </a-select>
              </a-form-item>
            </div>
          </div>
          <a-form-item label="Matter" class="">
            <a-input style="width: 72%">
              <a-tooltip slot="suffix" title="Extra information">
                <a-icon type="info-circle" style="color: rgba(0,0,0,.45)" />
              </a-tooltip>
            </a-input>
          </a-form-item>
        </vs-card>


        <vs-card class="mt-5">
          <div class="text-center">
            <div class="space-x-2">
              <a-button type="primary">Save Task</a-button>
              <a-button type="primary" ghost>Save & Add Another</a-button>
              or
              <a-button type="link">Cancel</a-button>
            </div>
          </div>
        </vs-card>

      </div>
    </div>
  </div>
</template>

<script>
    export default {
        name: "AddTask",
        data(){
          return{
            value: 1
          }
        }
    }
</script>

<style>


  [dir=ltr] .ant-select-selection-selected-value{
    float: inherit !important;
  }
  [dir=ltr] .ant-input-group.ant-input-group-compact > *:first-child, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-select:first-child > .ant-select-selection, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-calendar-picker:first-child .ant-input, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-select-auto-complete:first-child .ant-input, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-cascader-picker:first-child .ant-input, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-mention-wrapper:first-child .ant-mention-editor, [dir=ltr] .ant-input-group.ant-input-group-compact > .ant-time-picker:first-child .ant-time-picker-input{
    border-top-left-radius: 3px !important;
    border-bottom-left-radius: 3px !important;
  }
  [dir] .ant-icon{
    /*border-top-right-radius: 3px !important;*/
    /*border-bottom-right-radius: 3px !important;*/
  }
</style>
